(ns common.schema.entities.common.options
  "Option sets that more than one entity type uses. An option set that belongs to a
   single entity type is in the `options` namespace of that entity type.")

(def condition-true-false-options
  [{:key   :condition.status/true
    :label "Yes"}
   {:key   :condition.status/false
    :label "No"}])

(def needed-not-needed-options
  [{:key   :condition.status/true
    :label "Needed"}
   {:key   :condition.status/false
    :label "Not needed"}])
